import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import SectionLabel from "@/components/SectionLabel";
import { CTA, SITE } from "@/data/site";

export default function BookingCTA({
    eyebrow = "Prenota",
    title = "Prenota il tuo momento di benessere",
    subtitle,
    primary = CTA.primary,
    secondary = CTA.secondary,
}) {
    return (
        <section
            data-testid="booking-cta"
            className="relative py-20 md:py-28 overflow-hidden"
        >
            <div className="absolute inset-0 bg-rose-powder/45" />
            <div
                aria-hidden
                className="absolute -top-32 -left-40 w-[500px] h-[500px] rounded-full bg-raspberry/20 blur-3xl"
            />
            <div
                aria-hidden
                className="absolute -bottom-40 -right-32 w-[600px] h-[600px] rounded-full bg-sage/25 blur-3xl"
            />

            <div className="relative mx-auto max-w-[1200px] px-6 md:px-12">
                <Reveal>
                    <SectionLabel text={eyebrow} />
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-5 font-display text-[32px] md:text-[46px] leading-[1.08] text-ink max-w-4xl">
                        {title}
                    </h2>
                </Reveal>
                {subtitle && (
                    <Reveal delay={0.1}>
                    <p className="mt-5 text-ink-soft text-[16px] leading-relaxed max-w-2xl">
                        {subtitle}
                    </p>
                </Reveal>
                )}
                <Reveal delay={0.3}>
                    <div className="mt-10 flex flex-wrap items-center gap-4">
                        <Link
                            to={primary.href || "/contatti"}
                            className="group inline-flex items-center gap-3 rounded-full bg-raspberry text-ivory pl-6 pr-2 py-2.5 text-xs uppercase tracking-[0.24em] font-semibold hover:bg-raspberry-deep transition-all shadow-soft"
                        >
                            {primary.label}
                            <span className="w-9 h-9 rounded-full bg-ivory text-raspberry grid place-items-center group-hover:rotate-45 transition-transform duration-500">
                                <ArrowUpRight size={16} />
                            </span>
                        </Link>
                        <a
                            href={SITE.phoneHref}
                            className="inline-flex items-center gap-2 rounded-full border border-ink/15 bg-ivory/70 backdrop-blur px-6 py-3.5 text-xs uppercase tracking-[0.24em] font-semibold text-ink hover:bg-white transition-all"
                        >
                            <Phone size={14} />
                            {SITE.phone}
                        </a>
                    </div>
                </Reveal>

                <Reveal delay={0.4}>
                    <div className="mt-14 grid sm:grid-cols-3 gap-6 text-sm text-ink-soft">
                        <InfoBlock label="Indirizzo" value={`${SITE.address.street}, ${SITE.address.city}`} />
                        <InfoBlock
                            label="Contatti"
                            value={`${SITE.phone} · ${SITE.mobile}`}
                        />
                        <InfoBlock
                            label="Orari"
                            value={`Mar–Ven 09–18:30 · Sab 09–13`}
                        />
                    </div>
                </Reveal>
            </div>
        </section>
    );
}

function InfoBlock({ label, value }) {
    return (
        <div>
            <SectionLabel text={label} tone="muted" />
            <p className="mt-3 font-display text-xl md:text-2xl text-ink leading-snug">
                {value}
            </p>
        </div>
    );
}
